export const tr = {
    'mc-banner-recommendation-text': 'Grubu kaydetmek için anahtar sözcük gruplarını belirtin',
    'performance-recommendation-text': 'Grubu kaydetmek için gösterim koşullarını manuel olarak doldurun',
    'tgo-recommendation-text':
        'Grubu kaydetmek için otomatik hedeflemeyi etkinleştirin veya gösterim koşullarını manuel olarak doldurun'
};
